module.exports = __webpack_public_path__ + "img/icon_status@3x.3decc3c6.png";